import PropTypes from 'prop-types'
import { connectStateResults } from 'react-instantsearch-dom'

import { Box, Heading, Text } from '@redriverpress/system'
import { InfiniteHits } from 'Packages/search'

import Flashcard from './Flashcard'
import FlashcardsGrid from './FlashcardsGrid'

const FlashcardHit = ({ hit, userHasAccess }) => {
  // Injecting `userHasAccess` to InfiniteHits' hitComponent was causing a memory overload,
  // therefore we're getting `userHasAccess` via the hook for search result flashcards instead.
  // (In other places where the Flashcard component is used, it's easier to just pass this prop down.)

  const serializedFlashcard = {
    ...hit,
    categoryTitle: hit.category_title,
    image: hit.image_url,
    imageGrayscale: hit.image_grayscale_url,
    thumbnail: hit.thumbnail_url,
  }

  return (
    <Flashcard
      showCategory
      flashcard={serializedFlashcard}
      userHasAccess={userHasAccess}
    />
  )
}

FlashcardHit.propTypes = {
  hit: PropTypes.shape({
    category_title: PropTypes.string.isRequired,
    image_url: PropTypes.string.isRequired,
    image_grayscale_url: PropTypes.string.isRequired,
    thumbnail_url: PropTypes.string.isRequired,
  }).isRequired,
  userHasAccess: PropTypes.bool.isRequired,
}

function FlashcardSearchResults({ searchState, searchResults, userHasAccess }) {
  const nbHits = searchResults && searchResults.nbHits
  const { query } = searchState

  return (
    <Box as='section'>
      {searchResults && (
        <Box mb={4}>
          <Heading as='h3' mb={2}>
            Search results
          </Heading>
          <Text>
            {nbHits?.toLocaleString()} match{nbHits !== 1 && 'es'} for{' '}
            <Text as='span' fontWeight={600}>
              {query}
            </Text>
          </Text>
        </Box>
      )}
      <InfiniteHits
        hitComponent={FlashcardHit}
        hitsWrapper={FlashcardsGrid}
        hitComponentProps={{ userHasAccess }}
      />
    </Box>
  )
}

FlashcardSearchResults.defaultProps = {
  searchResults: null,
}

FlashcardSearchResults.propTypes = {
  searchState: PropTypes.shape({
    query: PropTypes.string,
  }).isRequired,
  searchResults: PropTypes.shape({
    nbHits: PropTypes.number,
  }),
  userHasAccess: PropTypes.bool.isRequired,
}

export default connectStateResults(FlashcardSearchResults)
